<template>
<router-view />
</template>

<script>
export default {
  name: 'SystemSettingsConfig',
  routeInfo: {
    label: '设置'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/04Config/index.vue